import { render, staticRenderFns } from "./CalculateAveragePrice.vue?vue&type=template&id=b26e035a&"
import script from "./CalculateAveragePrice.vue?vue&type=script&lang=js&"
export * from "./CalculateAveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports